<template>
  <div class="GoodsDetail">
    <div class="content">
      <div class="goodsInfo">
        <!-- <img
          class="infoLeft"
          :src="
            detail.rguiigpafo0pe0my && detail.rguiigpafo0pe0my.length > 0
              ? detail.rguiigpafo0pe0my[0].url
              : ''
          "
          alt="商品图片"
        /> -->
        <el-carousel height="400px" class="infoLeft" arrow="never">
          <el-carousel-item v-for="(item,index) in detail.rguiigpafo0pe0my" :key="index">
            <img :src="item.url" alt="" />
          </el-carousel-item>
        </el-carousel>
        <div class="infoRight">
          <div class="infoBox">
            <h3 class="name">{{ detail.avdrlfwlhg7kywxn }}</h3>
          </div>
          <div class="infoBox">
            <p>{{ detail.levmoblohezp7y50 || '' }}</p>
          </div>
          <div class="infoBox">
            <h3 class="price">¥{{ detail.f93blbqlvdtdt65v || 0 }}</h3>
          </div>
          <div class="infoBox">
            <span>单位：</span>{{ detail.y8cegh2yyvvqbzwo || '' }}
          </div>
          <template
            v-if="
              detail['2ubunrqlyoz3re9q'] !==
              '00bd865a-258c-4cf7-a79a-10124f2396e2'
            "
          >
            <div class="infoBox">
              <span>数量：</span>
              <NumberInput v-model="num" :min="1" :max="999999" />
            </div>
            <button class="buyBtn" @click="buy">立即购买</button>
            <button @click="addToCart">
              <img src="../../assets/img/home/gouwuche04.png" alt="" />
              加入购物车
            </button>
            <button class="buyBtn" type="text" @click="showDialogVisible">
              加入常购清单
            </button>
          </template>
        </div>
      </div>
      <section class="msgBox">
        <ul class="tagList">
          <li
            :class="{ selected: curIndex === index }"
            v-for="(item, index) in tagList"
            :key="'tag' + index"
            @click="changeIndex(index)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="commentBody" v-if="curIndex === 0">
          <div v-if="detail.tucgev7e0xvjfgij && detail.tucgev7e0xvjfgij.length">
            <img
              :src="item.url"
              alt=""
              v-for="(item, index) in detail.tucgev7e0xvjfgij"
              :key="index"
              class="img"
            />
          </div>
          <div
            class="richtext"
            v-else-if="
              detail.xwkkrha3mtpeybgy &&
              detail.xwkkrha3mtpeybgy !== '<p><br></p>'
            "
            v-html="detail.xwkkrha3mtpeybgy"
          ></div>
          <p class="emptyTips" v-else>
            <img src="../../assets/img/article.svg" alt="" />
          </p>
        </div>
        <div class="msgBody" v-else-if="curIndex === 1">
          <div
            v-if="
              detail.se3jrkgoqrxa6sgt &&
              detail.se3jrkgoqrxa6sgt !== '<p><br></p>'
            "
            v-html="detail.se3jrkgoqrxa6sgt"
          ></div>
          <p class="emptyTips" v-else>
            <img src="../../assets/img/article.svg" alt="" />
          </p>
        </div>
        <div class="msgBody" v-else>
          <div
            v-if="detail.g9rqvy80zjwm73qh && detail.g9rqvy80zjwm73qh.length > 0"
          >
            {{ detail.g9rqvy80zjwm73qh[0].value }}
          </div>
          <p class="emptyTips" v-else>
            <img src="../../assets/img/article.svg" alt="" />
          </p>
        </div>
      </section>
    </div>
    <el-dialog
      title="分组管理"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-select v-model="group" placeholder="请选择">
        <el-option
          v-for="item in groupList"
          :key="item.id"
          :label="item.izclrsecwsxu9yfg"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-link type="primary" :underline="false" @click="addGroup">
        新增分组
      </el-link>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addToFrequentPurchaseList()">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import NumberInput from "../../components/NumberInput";
import Radio from "../../components/Radio";
import GoodsItem from "../../components/GoodsItem";
import { detailOnline, relationFieldButtonExc, online, postOnline } from "@/api/platform";
export default {
  name: "GoodsDetail",
  components: {
    NumberInput,
    Radio,
    GoodsItem,
  },
  computed: {
    id () {
      return this.$route.params.id;
    },
  },
  data () {
    return {
      goodsImg: "",
      goodsName: "",
      goodsDesc: "",
      specs: [],
      typeId: "",
      temSpecId: 0,
      num: 1,
      msgList: [],
      askContent: "",
      tagList: ["商品介绍", "规格型号", "供货商"],
      curIndex: 0,
      rate: "",
      commentList: [],
      goodsList: [],
      detail: {},
      dialogVisible: false, //分组弹窗
      groupList: [], //分组列表
      group: '', // 分组id
    };
  },
  mounted () {
    this.detailOnline(this.id);
    this.getGroupList()
  },
  methods: {
    async detailOnline (id) {
      const { result } = await detailOnline({
        id,
        form_head_uuid: "4b9b935758484c01bb3d8e2d1e08211f",
      });
      this.detail = result;
    },
    // 获取分组列表
    async getGroupList () {
      const { result } = await online({
        form_head_uuid: 'fde4a97f88444d9599a9bbf4778a2767',
        page: 1,
        limit: 1000,
        keyword: "",
        select_option: "",
      });
      this.groupList = result
    },
    // 展示分组管理弹窗
    showDialogVisible () {
      this.dialogVisible = true;
      this.group = ''
    },

    changeIndex (i) {
      this.curIndex = i;
    },
    // 加入购物车
    async addToCart () {
      await relationFieldButtonExc({
        data: { bhekk5pld5l117tl: this.num },
        button_uuid: "e3bd545a-7298-4a1c-9441-6a69d58cc092",
        ids: [this.detail.id],
        form_head_uuid: "4b9b935758484c01bb3d8e2d1e08211f",
      });
      this.$notify({
        title: "提示",
        message: "商品已成功加入购物车",
        type: "success",
      });
      this.num = 1;
      this.$store.dispatch('getCartQuantity');
    },
    addGroup () {
      this.$prompt('分组名称', '新增分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        if (value) {
          await postOnline({
            form_head_uuid: "fde4a97f88444d9599a9bbf4778a2767",
            izclrsecwsxu9yfg: value,
          })
          this.$message({
            type: 'success',
            message: '创建成功'
          });
          this.getGroupList()
        }
      })
    },
    // 加入常购清单
    async addToFrequentPurchaseList () {
      await relationFieldButtonExc({
        data: { abv2ns1jpglwrhpt: this.group, cqciysjw6yzbccda: this.num },
        button_uuid: "4aeb190e-43e6-4ed3-99aa-33d7d1bc24aa",
        ids: [this.detail.id],
        form_head_uuid: "1906dfc5e0ce4e7cb7d6324b06e6d470",
      });
      this.$notify({
        title: "提示",
        message: "商品已成功加入常购清单",
        type: "success",
      });
      this.dialogVisible = false
      this.num = 1;
    },
    // 立即购买
    buy () {
      this.$store.commit('setData', {
        commodityList: [this.detail],
        number: this.num
      });
      this.$router.push('/mall/createOrder?form=detail')
    },
  },
  watch: {
    $route (to, from) {
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.GoodsDetail {
  .content {
    width: 100%;
    padding-top: 20px;
    .goodsInfo {
      width: 100%;
      overflow: hidden;
      .infoLeft {
        display: inline-block;
        width: 400px;
        height: 400px;
        float: left;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .infoRight {
        display: inline-block;
        float: right;
        width: 700px;
        .infoBox {
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          .name {
            font-size: 20px;
            color: #666666;
            font-weight: bold;
          }
          p {
            color: @fontDefaultColor;
            font-size: 15px;
          }
          .price {
            font-size: 35px;
            color: @falseColor;
          }
          span {
            color: @fontDefaultColor;
            font-size: 13px;
            display: inline-block;
            width: 50px;
          }
          .tips {
            width: auto;
            margin: 0 20px 0 5px;
          }
          .NumberInput {
            display: inline-block;
            vertical-align: middle;
          }
        }
        button {
          background-color: #de531d;
          width: 180px;
          height: 46px;
          color: white;
          border: none;
          font-size: 19px;
          margin-right: 20px;
          margin-top: 10px;
          &:hover {
            opacity: 0.8;
          }
        }
        .buyBtn {
          border: 1px solid #de531d;
          color: #de531d;
          background-color: #ffefe8;
        }
      }
    }
    .msgBox {
      margin: 50px 0;
      border: 1px solid @borderColor;
      padding-top: 0;
      .tagList {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid @borderColor;
        background-color: #f5f5f5;
        li {
          width: 170px;
          height: 42px;
          position: relative;
          top: -2px;
          display: inline-block;
          text-align: center;
          line-height: 40px;
          font-size: 13px;
          cursor: pointer;
          &:hover {
            color: @thirdColor;
          }
        }
        .selected {
          background-color: white;
          border-top: 4px solid @thirdColor;
        }
      }
      .commentBody {
        padding: 20px;
        min-height: 300px;
        .img {
          width: 100%;
          vertical-align: bottom;
        }
      }
      .richtext {
        width: 100%;
        /deep/img {
          p {
            vertical-align: bottom;
          }
          width: 100%;
          vertical-align: bottom;
        }
      }
      .msgBody {
        padding: 20px;
        min-height: 300px;
      }
    }
  }
  .ban {
    user-select: none;
    cursor: not-allowed;
  }
}
.emptyTips {
  margin: 100px auto;
  text-align: center;
}
/deep/ .el-dialog__body {
  display: flex;
  justify-content: flex-start;
  .el-select {
    width: 100%;
  }
  .el-link {
    flex-shrink: 0;
    margin-left: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/GoodsDetail.vue